
// import React, { useState } from "react";

import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import useApi from "../../../CustomHooks/useApi";
import { Wallet, Loader2 } from "lucide-react";
import { openPrint } from "../../../Store/Slices/printSlice";

const AepsSettlementSoliteckLogin = () => {
    const navigate = useNavigate();
 const dispatch = useDispatch();
    // Form States
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [fName, setFName] = useState("");
    const [lName, setLName] = useState("");
    const [pincode, setPincode] = useState("");

    // Soliteck Specific API States
    const [dbStatus, setDbStatus] = useState(null);
    const [vendorId, setVendorId] = useState(null);
    const [step, setStep] = useState(0); // 0 = Mobile Check, 1 = OTP/Register
    const [requiresName, setRequiresName] = useState(false); // ✅ Tracks if API asked for FName/LName

    // UI States
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // APIs
    const { callApi: loginRemitter } = useApi("/soliteck/remitter/login", "GET");
    const { callApi: registerRemitter } = useApi("/soliteck/remitter/register", "POST");
  const { callApi: fetchLedger } = useApi("/admin/transactions/retailer/recent-transactions", "GET");
    /* ================= STEP 1: CHECK CUSTOMER / LOGIN ================= */
    const handleCheckMobile = async () => {
        if (!/^[6-9]\d{9}$/.test(mobile)) {
            setMessage("Enter a valid 10-digit mobile number");
            setMessageType("error");
            return;
        }

        // Validate names if the API previously requested them
        if (requiresName && (!fName.trim() || !lName.trim())) {
            setMessage("First Name and Last Name are required to proceed.");
            setMessageType("error");
            return;
        }

        setIsLoading(true);
        setMessage("");

        try {
            // Build query dynamically. Start with just mobile.
            let queryStr = `?remitterMobile=${mobile}`;
            
            // Append names if the flag is true
            if (requiresName) {
                queryStr += `&remitterFName=${fName.trim()}&remitterLName=${lName.trim()}`;
            }

            const res = await loginRemitter(null, queryStr); 

            // ✅ Check if API returned 202 asking for names
            if (res?.error_code === 202 || res?.status === 202) {
                if (res?.message?.includes("FName & LName is required")) {
                    setRequiresName(true); // Trigger UI to show name inputs
                    setIsLoading(false);
                    return; // Stop here, wait for user to enter names and click again
                }
            }

            // Check if OTP needs to be verified (New or Partial Remitter)
            if (res?.responseCode === 201 || res?.responseCode === "201") {
                const currentDbStatus = res?.DBStatus || res?.dbStatus || (res?.responseData && res.responseData.DBStatus);
                const currentVendorId = res?.VendorId || res?.vendorId || (res?.responseData && res.responseData.VendorId);

                setDbStatus(String(currentDbStatus));
                setVendorId(String(currentVendorId));
                setStep(1); // Move to OTP Verification Step
                
                setMessage(res.message || "OTP sent to mobile number.");
                setMessageType("success");
            } 
            // Check if user is already fully registered and logged in
            else if (res?.remitterName || res?.availableLimit) {
                navigate("/settlementremitter2", {
                    state: { 
                        mobile, 
                        name: res.remitterName,
                        availableLimit: res.availableLimit,
                        monthlyLimit: res.monthlyLimit,
                        beneficiaryList: res.beneficiaryList || [],
                        allBeneficiaryList: res.allBeneficiaryList || []
                    },
                });
            } else {
                setMessage(res?.message || "Failed to fetch remitter details.");
                setMessageType("error");
            }
        } catch (err) {
            console.error(err);
            setMessage("Server error during login check.");
            setMessageType("error");
        }

        setIsLoading(false);
    };

    /* ================= STEP 2: VERIFY OTP & REGISTER ================= */
    const handleVerifyAndRegister = async () => {
        if (otp.length !== 6) {
            setMessage("Enter a valid 6-digit OTP");
            setMessageType("error");
            return;
        }

        // If DBStatus is "0", validate the extra required fields
        if (dbStatus === "0") {
            if (!fName.trim() || !lName.trim()) {
                setMessage("First Name and Last Name are required.");
                setMessageType("error");
                return;
            }
            if (!/^\d{6}$/.test(pincode)) {
                setMessage("Enter a valid 6-digit Pincode.");
                setMessageType("error");
                return;
            }
        }

        setIsLoading(true);
        setMessage("");

        try {
            const payload = {
                otp,
                dbStatus,
                vendorId
            };

            if (dbStatus === "0") {
                payload.fName = fName.trim();
                payload.lName = lName.trim();
                payload.pincode = pincode;
            }

            const res = await registerRemitter(payload);

            if (res?.status === "SUCCESS" || res?.status_code === 200) {
                setMessage("Remitter Registered Successfully!");
                setMessageType("success");

                setTimeout(() => {
                    navigate("/settlementremitter2", {
                        state: { 
                            mobile, 
                            name: dbStatus === "0" ? `${fName} ${lName}` : "Customer" 
                        },
                    });
                }, 1000);
            } else {
                setMessage(res?.message || "OTP Verification Failed");
                setMessageType("error");
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to verify OTP and register.");
            setMessageType("error");
        }

        setIsLoading(false);
    };
const [ledger, setLedger] = useState([]);
  const [loadingLedger, setLoadingLedger] = useState(false);

  const mid = useSelector((s) => s.auth.employeeDetails?.username);

     useEffect(() => {
        const loadLedger = async () => {
          if (!mid) return;
          setLoadingLedger(true);
    
          try {
            const res = await fetchLedger(null, `?mid=${mid}`);
    
            // ✅ Sirf data object uthao
            const onlyData = res?.slice(0, 5).map(item => item.data);
    
            setLedger(onlyData || []);
    
          } catch (err) {
            console.error("Ledger fetch failed:", err);
          } finally {
            setLoadingLedger(false);
          }
        };
    
        loadLedger();
      }, [mid]);
    return (
        <>
        <div className=" bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 mt-8 my-2 flex flex-col lg:flex-row gap-8 justify-center">
            
            <div className="w-full  bg-white border border-slate-200 rounded-2xl shadow-md p-6 sm:p-8 flex flex-col gap-6">

                {/* Heading */}
                <div className="flex items-start gap-5">
                    <div className="w-14 h-14 rounded-2xl bg-[#F6F6F6] flex items-center justify-center text-[#12345A] shadow-lg shrink-0">
                        <Wallet className="w-8 h-8" />
                    </div>
                    <div>
                        <h2 className="text-2xl font-semibold text-slate-800">
                            AEPS Settlement 1 (IMPS2) 
                        </h2>
                        <p className="text-gray-500 text-sm mt-1">
                            Verify mobile identity and register new remitters for secure transfers.
                        </p>
                        <p className="text-red-600 font-bold text-sm mt-1.5">
                            ⚡ Instant Success Guaranteed (₹5k to ₹25k)
                        </p>
                    </div>
                </div>

                {/* Form Area */}
                <div className="max-w-full space-y-5">

                    {/* Step 0: Mobile Number Input & Conditional Names */}
                    {step === 0 && (
                        <div className="space-y-4">
                            <div>
                                <label className="text-xl font-medium text-slate-700 block mb-2">Mobile Number</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    value={mobile}
                                    maxLength={10}
                                    onKeyDown={(e) => e.key === 'Enter' && handleCheckMobile()}
                                    onChange={(e) => /^\d*$/.test(e.target.value) && setMobile(e.target.value)}
                                    className="w-full min-h-[60px] sm:min-h-[70px] px-4 py-3 rounded-xl border border-[#12345A] 
                                               focus:ring-2 focus:ring-indigo-100 transition 
                                               text-xl sm:text-[22px] text-red-600 font-bold bg-[#F6F6F6] shadow-sm"
                                    placeholder="Enter 10-digit mobile number"
                                />
                            </div>

                            {/* ✅ Appears only if API asks for Names */}
                            {requiresName && (
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 animate-[fadeIn_.3s_ease-out]">
                                    <div>
                                        <label className="text-sm font-semibold text-slate-700 block mb-1">First Name</label>
                                        <input
                                            value={fName}
                                            onChange={(e) => setFName(e.target.value)}
                                            className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:border-[#12345A] focus:ring-1 focus:ring-[#12345A] text-lg bg-white"
                                            placeholder="Enter First Name"
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm font-semibold text-slate-700 block mb-1">Last Name</label>
                                        <input
                                            value={lName}
                                            onChange={(e) => setLName(e.target.value)}
                                            onKeyDown={(e) => e.key === 'Enter' && handleCheckMobile()}
                                            className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:border-[#12345A] focus:ring-1 focus:ring-[#12345A] text-lg bg-white"
                                            placeholder="Enter Last Name"
                                        />
                                    </div>
                                </div>
                            )}

                            <button
                                onClick={handleCheckMobile}
                                disabled={isLoading}
                                className="w-full mt-4 px-4 py-4 bg-[#12345A] hover:bg-[#0F2E47] text-white rounded-xl font-bold shadow-md transition disabled:opacity-70"
                            >
                                {isLoading ? "Checking Status..." : "Proceed Securely"}
                            </button>
                        </div>
                    )}

                    {/* Step 1: OTP & Registration Fields */}
                    {step === 1 && (
                        <div className="space-y-4 pt-4 border-t border-slate-200">
                            
                            {/* Mobile Number Locked Display */}
                            <div>
                                <label className="text-sm font-semibold text-slate-700 block mb-1">Mobile Number</label>
                                <input
                                    value={mobile}
                                    disabled
                                    className="w-full px-4 py-3 rounded-xl border border-slate-300 bg-gray-100 text-lg font-semibold text-gray-500"
                                />
                            </div>

                            {/* If DBStatus is 0, require full registration details */}
                            {dbStatus === "0" && (
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="text-sm font-semibold text-slate-700 block mb-1">First Name</label>
                                        <input
                                            value={fName}
                                            onChange={(e) => setFName(e.target.value)}
                                            placeholder="e.g. Naveen"
                                            className="w-full px-4 py-4 rounded-xl border border-slate-300 focus:border-[#12345A] focus:ring-1 focus:ring-[#12345A] text-lg bg-white"
                                        />
                                    </div>
                                    <div>
                                        <label className="text-sm font-semibold text-slate-700 block mb-1">Last Name</label>
                                        <input
                                            value={lName}
                                            onChange={(e) => setLName(e.target.value)}
                                            placeholder="e.g. Doda"
                                            className="w-full px-4 py-4 rounded-xl border border-slate-300 focus:border-[#12345A] focus:ring-1 focus:ring-[#12345A] text-lg bg-white"
                                        />
                                    </div>
                                    <div className="sm:col-span-2">
                                        <label className="text-sm font-semibold text-slate-700 block mb-1">Pincode</label>
                                        <input
                                            value={pincode}
                                            maxLength={6}
                                            inputMode="numeric"
                                            onChange={(e) => /^\d*$/.test(e.target.value) && setPincode(e.target.value)}
                                            placeholder="e.g. 110001"
                                            className="w-full px-4 py-4 rounded-xl border border-slate-300 focus:border-[#12345A] focus:ring-1 focus:ring-[#12345A] text-lg bg-white"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* OTP Input (Always Required in Step 1) */}
                            <div>
                                <label className="text-sm font-semibold text-slate-700 block mb-1">Enter 6-Digit OTP</label>
                                <input
                                    value={otp}
                                    maxLength={6}
                                    inputMode="numeric"
                                    onChange={(e) => /^\d*$/.test(e.target.value) && setOtp(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleVerifyAndRegister()}
                                    placeholder="Enter OTP"
                                    className="w-full px-4 py-4 rounded-xl border border-[#12345A] text-[22px] font-bold tracking-widest text-center bg-[#F6F6F6] shadow-inner"
                                />
                            </div>

                            <button
                                onClick={handleVerifyAndRegister}
                                disabled={isLoading}
                                className="w-full py-4 bg-green-600 hover:bg-green-700 text-white rounded-xl font-bold flex items-center justify-center gap-2 transition disabled:opacity-70"
                            >
                                {isLoading && <Loader2 className="animate-spin w-5 h-5" />}
                                {isLoading ? "Verifying..." : "Verify OTP & Register"}
                            </button>
                        </div>
                    )}

                    {/* Message Alerts */}
                    {message && (
                        <div className={`px-4 py-4 rounded-xl text-sm font-medium border ${
                            messageType === "success"
                                ? "bg-green-50 text-green-700 border-green-200"
                                : "bg-red-50 text-red-700 border-red-200"
                        }`}>
                            {message}
                        </div>
                    )}

                </div>
            </div>
        </div>



        {/* table */}
        
                    <div className="bg-white rounded-2xl p-6">
                    
                              {/* Header */}
                              <div className="flex items-center justify-between mb-4">
                                <h3 className="text-lg font-semibold text-slate-700">
                                  Recent Transaction
                                </h3>
                              </div>
                    
                              {/* Table */}
                              <div className="overflow-x-auto border rounded-xl">
                                <table className="w-full text-sm">
                                  <thead className="bg-slate-100">
                                    <tr>
                                      <th className="px-3 py-3 text-center">Action</th>
                                      <th className="px-3 py-3 text-left">Date</th>
                                      <th className="px-3 py-3 text-left">Txn ID</th>
                                      <th className="px-3 py-3 text-left">Amount</th>
                                      <th className="px-3 py-3 text-left">Beni</th>
                                      <th className="px-3 py-3 text-left">Account</th>
                                      <th className="px-3 py-3 text-left">Status</th>
                                    </tr>
                                  </thead>
                    
                                  <tbody className="divide-y">
                                    {loadingLedger ? (
                                      <tr>
                                        <td colSpan="7" className="py-10 text-center text-slate-500">
                                          Loading...
                                        </td>
                                      </tr>
                                    ) : ledger.length > 0 ? (
                                      ledger.map((r, i) => (
                                        <tr key={i} className="hover:bg-slate-50">
                    
                                          <td className="px-3 py-3 text-center">
                                            <button
                                              onClick={() => dispatch(openPrint(r))}
                                              className="hover:scale-110 transition"
                                            >
                                              🖨
                                            </button>
                                          </td>
                    
                                          <td className="px-3 py-3 whitespace-nowrap">
                                            {r.date
                                              ? new Date(r.date).toLocaleDateString("en-GB")
                                              : "-"}
                                          </td>
                    
                                          <td className="px-3 py-3 font-medium">
                                            {r.txnId || "-"}
                                          </td>
                    
                                          <td className="px-3 py-3 font-semibold text-green-600">
                                            ₹{r.netAmount?.toFixed(2) || r.amount?.toFixed(2) || "0.00"}
                                          </td>
                    
                                          <td className="px-3 py-3">
                                            {r.consumerNumber || r.beneficiary_name || "-"}
                                          </td>
                    
                                          <td className="px-3 py-3">
                                            {r.beneficiary_account_number || r.aeps_AadhaarNo || "-"}
                                          </td>
                    
                                          <td
                                            className={`px-3 py-3 font-semibold ${(r.txnStatus === "SUCCESS" || r.status === "SUCCESS")
                                              ? "text-green-600"
                                              : r.txnStatus === "FAILED"
                                                ? "text-red-600"
                                                : "text-yellow-600"
                                              }`}
                                          >
                                            {r.txnStatus || r.status || "-"}
                                          </td>
                    
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="7" className="py-10 text-center text-slate-400">
                                          No records found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                    
                            </div>
                            </>

    );
};

export default AepsSettlementSoliteckLogin;